/** Posizione GPS letta al salvataggio dell'ordine.
 *  Attiva solo se l'admin ha abilitato il permesso "Posizione ordini" sull'utente.
 *  Non blocca mai: se il permesso è negato o il GPS non risponde ritorna null. */
export async function capturePosition(timeoutMs = 8000) {
  if (!navigator.geolocation) return null;
  try {
    const pos = await new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(resolve, reject, {
        enableHighAccuracy: true,
        timeout: timeoutMs,
        maximumAge: 60000,
      });
    });
    return {
      geo_lat: pos.coords.latitude,
      geo_lng: pos.coords.longitude,
      geo_accuracy: Math.round(pos.coords.accuracy || 0),
      geo_at: new Date().toISOString(),
    };
  } catch {
    return null;
  }
}

/** Da usare nelle schermate di creazione ordine. */
export async function maybeCapturePosition(user) {
  if (!user?.geo_tracking) return null;
  return capturePosition();
}

/** true quando l'app gira dentro un iframe (anteprima): il browser blocca il
 *  permesso posizione senza mostrare alcun popup. */
export function isInIframe() {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
}

/** 'granted' | 'denied' | 'prompt' | 'unsupported' */
export async function getGeoPermissionState() {
  if (!navigator.geolocation) return "unsupported";
  try {
    const st = await navigator.permissions.query({ name: "geolocation" });
    return st.state;
  } catch {
    return "prompt";
  }
}

/** Chiede il permesso GPS (va invocata da un gesto dell'utente).
 *  Ritorna { ok: true } oppure { ok: false, reason: 'denied'|'unavailable'|'timeout' }. */
export function requestGeoPermission() {
  if (!navigator.geolocation) return Promise.resolve({ ok: false, reason: "unsupported" });
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      () => resolve({ ok: true }),
      (err) => {
        const reason = err.code === 1 ? "denied" : err.code === 3 ? "timeout" : "unavailable";
        resolve({ ok: false, reason });
      },
      { enableHighAccuracy: true, timeout: 15000, maximumAge: 300000 }
    );
  });
}

export const mapsLink = (lat, lng) => `https://www.google.com/maps?q=${lat},${lng}`;
